module.exports = __webpack_public_path__ + "img/title-bg.a46c5dfd.png";